const steps = [
  {
    n: "01",
    title: "Copy the ad URL",
    body: "Head to Meta's Ad Library, find the ad, and copy its link — snapshot URLs work too.",
  },
  {
    n: "02",
    title: "Paste & fetch",
    body: "Drop the URL in our input above and we'll pull the raw media from Meta's servers.",
  },
  {
    n: "03",
    title: "Download the assets",
    body: "One click gets you HD video, SD fallback, and the ad thumbnail — ready to remix.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative py-20 md:py-28 border-t border-zinc-200 dark:border-zinc-800 bg-zinc-100/60 dark:bg-zinc-950/40"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14">
          <p className="text-xs font-mono uppercase tracking-widest text-yellow-500 mb-3">
            // The 12-second workflow
          </p>
          <h2 className="font-display font-bold text-4xl md:text-6xl text-zinc-900 dark:text-white tracking-tight leading-[0.95] max-w-3xl">
            Three steps. Zero friction.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-l border-zinc-200 dark:border-zinc-800">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`step-${i}`}
              className="relative border-r border-b border-zinc-200 dark:border-zinc-800 p-8 md:p-10 group hover:bg-white dark:hover:bg-black transition-colors overflow-hidden"
            >
              <span
                className="absolute top-4 right-4 font-display font-extrabold text-8xl md:text-9xl text-zinc-100 dark:text-zinc-900 group-hover:text-yellow-500/20 transition-colors leading-none select-none"
                aria-hidden
              >
                {s.n}
              </span>
              <div className="relative">
                <div className="inline-block bg-yellow-500 text-black font-mono text-xs px-2 py-1 font-bold">
                  STEP {s.n}
                </div>
                <h3 className="mt-6 font-display font-bold text-2xl md:text-3xl text-zinc-900 dark:text-white tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-zinc-400 dark:text-zinc-600 dark:text-zinc-400 leading-relaxed max-w-xs">
                  {s.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
